import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import tick from '../../../../assets/images/tick.png'
import BookingForm from '../../../../components/BookingForm'
import { useDispatch, useSelector } from 'react-redux'
import { setAppLoading, setMessage } from '../../../../store/common/generalSlice'
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi'
import { useLocation, useNavigate } from 'react-router-dom'
import { filtersDataFormatter } from '../../../../config/utils/FiltersDataFormatter'

const GetQuote = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();

    const { createBooking } = useBookingApi()

    const [allServices, setAllServices] = useState([])

    // getting all the services from store.
    const { services } = useSelector(state => state?.services);

    // setting the data to the format specific for advanced filters component
    useEffect(() => {
        if (services) {
            setAllServices(filtersDataFormatter(services))
        }
    }, [services])


    const bookingFormDataOrStatusHandler = async (data) => {
        try {
            dispatch(setAppLoading(true))

            const temp = structuredClone(data)
            const payload = {
                ...temp?.fetchedVehicleData,
                ...temp?.location,
                serviceProviderId: null,
                quote: true,
                ...temp
            }
            payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
            // payload.services = [].concat(...Object.values(temp?.services))
            payload.services = data?.services //dev env
            // payload.services = [77,80,83] //qa env
            payload.year = payload.year + ''

            const keysToDelete = [
                'vehicleRegistrationNumber',
                'id',
                'createdAt',
                'carRegNo',
                'isApproved',
                'status',
                'updatedAt',
                'forgot',
                'fetchedVehicleData',
                'location',
                'userId'
            ]
            for (let i = 0; i < keysToDelete.length; i++) {
                delete payload[keysToDelete[i]]
            }

            const response = await createBooking(payload)
            if (response) {
                dispatch(setAppLoading(false))

                dispatch(setMessage(response?.data?.message))
                navigate('/quotes')
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }


    return (
        <div>
            <h5 className='heading-5 font-semibold'>Request New Quote</h5>
            <Row className='w-full my-4 bg-white px-2 rounded-md py-6 flex justify-between gap-6'>
                <Col lg={14} md={12} sm={24} xs={24} className='flex flex-col gap-2 pl-2'>
                    <h4 className='heading-4 font-semibold'>How to Book a Car Service Near You</h4>
                    <div className='flex flex-col gap-4 pl-4 my-4'>
                        <div className='flex items-center gap-3'>
                            <span>1.</span>
                            <span>Enter your vehicle reg and postcode.</span>
                        </div>
                        <div className='border-b border-dashed border-gray-400'></div>
                        <div className='flex items-center gap-3'>
                            <span>2.</span>
                            <span>Compare deals. You can sort garages in your area by whatever best suits your needs: price, distance, reviews and ratings or availability.</span>
                        </div>
                        <div className='border-b border-dashed border-gray-400'></div>
                        <div className='flex items-center gap-3'>
                            <span>3.</span>
                            <span>Pick a date and time for your appointment.</span>
                        </div>
                    </div>
                    <div>
                        <p>
                            After you book your service, we send you a confirmation email with a summary of your booking. We also contact the garage who may also contact you to confirm your car service booking and/or ask for extra details.<br></br><br></br> You never pay for your booking until after all the work has been completed and deal with the garage directly after the initial booking process. You also have the ability to change or cancel your booking for free until the day of your appointment.
                        </p>
                    </div>
                </Col>

                <Col lg={7} md={9} sm={16} xs={24} className='p-3 custom-card-boxshadow bg-black rounded-md w-full mx-auto md:mx-0'>
                    <h3 className='heading-4 text-white'>Book Service</h3>
                    <p className='text-white font-light'>Vehicle Registration</p>
                    <div className='w-full py-2 flex flex-col gap-1 mt-5'>
                        <BookingForm
                            bookingFormDataOrStatusHandler={bookingFormDataOrStatusHandler}
                            spServicesData={allServices}
                            editData={location?.state ? location.state : null}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default GetQuote